import { createSlice } from '@reduxjs/toolkit';
import {
  getNewConnectionDetails,
  getReportSummary,
  getStoreStepDetails,
  getStoreStepDetailsLastUpdate
} from './Connector.action';

export const initialState = {
  newConnectionDetails: {},
  storeStepDetails: {},
  reportSummary: {}
};

export const connectorSlice = createSlice({
  name: 'connector',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getNewConnectionDetails.pending, state => {
      state.newConnectionDetails = {
        loading: true,
        error: false,
        data: []
      };
    });
    builder.addCase(getNewConnectionDetails.fulfilled, (state, action) => {
      state.newConnectionDetails = {
        loading: false,
        error: false,
        data: action.payload
      };
    });
    builder.addCase(getNewConnectionDetails.rejected, (state, action) => {
      state.newConnectionDetails = {
        loading: false,
        error: true,
        data: []
      };
    });
    builder.addCase(getStoreStepDetails.pending, state => {
      state.storeStepDetails = {
        loading: true,
        error: false,
        data: []
      };
    });
    builder.addCase(getStoreStepDetails.fulfilled, (state, action) => {
      state.storeStepDetails = {
        loading: false,
        error: false,
        // ...action.payload
        data: action.payload
      };
    });
    builder.addCase(getStoreStepDetails.rejected, state => {
      state.storeStepDetails = {
        loading: false,
        error: true,
        data: []
      };
    });
    builder.addCase(getStoreStepDetailsLastUpdate.pending, state => {
      state.lastUpdatedStoreStepDetails = {
        loading: true,
        error: false,
        data: []
      };
    });
    builder.addCase(getStoreStepDetailsLastUpdate.fulfilled, (state, action) => {
      state.lastUpdatedStoreStepDetails = {
        loading: false,
        error: false,
        // ...action.payload
        data: action.payload
      };
    });
    builder.addCase(getStoreStepDetailsLastUpdate.rejected, state => {
      state.lastUpdatedStoreStepDetails = {
        loading: false,
        error: true,
        data: []
      };
    });
    builder.addCase(getReportSummary.pending, state => {
      state.reportSummary = {
        loading: true,
        error: false,
        data: []
      };
    });
    builder.addCase(getReportSummary.fulfilled, (state, action) => {
      state.reportSummary = {
        loading: false,
        error: false,
        data: action.payload
      };
    });
    builder.addCase(getReportSummary.rejected, state => {
      state.reportSummary = {
        loading: false,
        error: true,
        data: []
      };
    });
  }
});

export default connectorSlice.reducer;
